const SET = 'locationKept/SET'

export const setLocationKept = (locationKept: boolean) => {
  return {
    locationKept,
    type: SET,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.locationKept
    default:
      return state
  }
}
